var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('AddNewWhitelist'),_c('div',{staticClass:"mt-4"},[_c('WhitelistedAddresses')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }